import { render, staticRenderFns } from "./APIKeys.vue?vue&type=template&id=1008e905&"
import script from "./APIKeys.vue?vue&type=script&lang=js&"
export * from "./APIKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports